import * as React from 'react';

/** Material UI Packages. */
import { useMediaQuery } from '@mui/material';

/** Auth0 authenticator Packages. */
import { useAuth0 } from '@auth0/auth0-react';

/** Internal Components. */
import deactivated from 'statics/images/deactivated.png';
import { BREAKPOINTS } from 'shared/config/PageStyles';

import PageLayout from './pageLayout';

export default function ErrorPage() {
    /** Redirect user if the token is invalid. */
    const { logout } = useAuth0();

    /** Detecting window size for responsive web. */
    const isMediumScreen = useMediaQuery(`(max-width: ${BREAKPOINTS.SMALL}px)`);

    /** When logout button click, redirect to endpoint : /login.  */
    const handleLogout = () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    const descriptions = [
        "Sorry, we can't seem to find that page.",
        "It might have been removed or doesn't exist anymore.",
    ];

    return (
        <PageLayout
            backgroundImage={deactivated}
            title="404 PAGE NOT FOUND"
            description={descriptions}
            buttonText="Go Home"
            onButtonClick={handleLogout}
            isMediumScreen={isMediumScreen}
        />
    );
}
